import { Location } from '../../../clients/quipli-service/location/location';
import { Interval } from 'luxon';

export const filterRangeToShopHours = (
  interval: Interval,
  locations: Location[],
  filteredLocation: Location | undefined = undefined,
  disabledDaysFullDays: boolean = true,
): Interval | null => {
  if (interval.length('days') <= 1) {
    // Get the relevant locations
    const relevantLocations = filteredLocation ? [filteredLocation] : locations;

    if (relevantLocations.length === 0) {
      return interval;
    }

    // Find the minimum start time and maximum end time from all location hours of operation
    let minStartTime: string | null = null;
    let maxEndTime: string | null = null;

    relevantLocations.forEach((location) => {
      location.hoursOfOperation.forEach((dailyHours) => {
        if (dailyHours.isEnabled) {
          // Check if this day matches the interval's day of week
          const intervalDayOfWeek = interval.start.weekday;
          if (dailyHours.numericDayOfWeek === intervalDayOfWeek) {
            // Update min start time
            if (minStartTime === null || dailyHours.rentalStart.start < minStartTime) {
              minStartTime = dailyHours.rentalStart.start;
            }
            // Update max end time
            if (maxEndTime === null || dailyHours.rentalEnd.end > maxEndTime) {
              maxEndTime = dailyHours.rentalEnd.end;
            }
          }
        }
      });
    });

    // If we found valid hours, create a new interval with those hours
    if (minStartTime !== null && maxEndTime !== null) {
      const startParts = (minStartTime as string).split(':');
      const endParts = (maxEndTime as string).split(':');
      const startHour = parseInt(startParts[0], 10);
      const startMinute = parseInt(startParts[1], 10);
      const endHour = parseInt(endParts[0], 10);
      const endMinute = parseInt(endParts[1], 10);

      const startDateTime = interval.start.set({
        hour: startHour,
        minute: startMinute,
        second: 0,
        millisecond: 0,
      });

      const endDateTime = interval.start.set({
        hour: endHour,
        minute: endMinute,
        second: 0,
        millisecond: 0,
      });

      return Interval.fromDateTimes(startDateTime, endDateTime);
    } else if (!disabledDaysFullDays) {
      return null;
    }
  }

  return interval;
};
